import { NavLink } from 'react-router-dom';
import '../style/SideMenu.css'; // Optional for styles

const SideMenu = () => {
  const pages = [
    { name: 'Home', path: '/' },
    { name: 'MIT', path: '/MIT' },
    { name: 'Cards', path: '/cards' },
    { name: 'Acceptance Logic Page', path: "/acceptance-logic-page"},
    { name: 'Lead and Connect', path: "/lead-and-connect"}
  ];

  return (
    <div className={`side-menu`}>
      <nav>
        <ul>
          {pages.map((page) => (
            <li key={page.path}>
              <NavLink to={page.path} activeClassName="active">
                {page.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SideMenu;
